module.exports = __webpack_public_path__ + "img/cazoo-logo.fe54165d.png";